import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

function shallowize(obj = {}, holder = {}, prefix = '', separator = '_') {
  let returnValue = Object.assign({}, holder)

  for (const key of Object.keys(obj)) {
    const prefixedKey = prefix ? prefix + separator + key : key
    if (obj[key] && typeof obj[key] === 'object') {
      returnValue = shallowize(obj[key], returnValue, prefixedKey, separator)
    } else {
      returnValue[prefixedKey] = obj[key]
    }
  }

  return returnValue
}

class CartEnd extends React.Component {
  componentDidMount() {
    const { resourceId, amount, cart, currency } = this.props

    console.debug('cart', cart)

    window.fbq && window.fbq('track', 'Purchase', {
      content_type: 'product',
      content_category: 'event',
      content_name: resourceId,
      content_ids: [resourceId],
      value: amount,
      currency,
    }, { eventID: cart.resourceId || 'MISSING_ID' })
    window.ga && window.ga('send', {
      hitType: 'event',
      eventCategory: 'Reservations',
      eventAction: 'Purchase',
      eventLabel: 'Purchase completed',
      eventValue: amount,
      currency,
    })
    window.gtag && window.gtag('event', 'purchase', {
      transaction_id: resourceId,
      value: amount,
      currency,
    })
    window.scrollTo(0, 0)
  }

  render() {
    const { cart, topComponent } = this.props
    const { data } = cart
    const { type } = data

    const top = topComponent
      ? (<div className="space--bottom-2">{ topComponent }</div>)
      : null

    return (
      <div className="reservation-step">
        <h1 className="reservation-step__title">
          <FormattedMessage id={ `app.cart.step.end.thanks.${type}` } />
        </h1>
        <div className="reservation-step__content">
          { top }
          <p className="space--both-2">
            <FormattedHTMLMessage
              id={ `app.cart.step.end.instructions.${type}` }
              values={ shallowize(data) }
            />
          </p>
          <hr id="cart-end__hr" />
          <div className="grid space--top-2">
            <div className="grid__item lap-6-12">
              { this.props.paymentInfo }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CartEnd.propTypes = {
  cart: PropTypes.object.isRequired,
  resourceId: PropTypes.string,
  paymentInfo: PropTypes.object.isRequired,
  topComponent: PropTypes.node,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
}

export default CartEnd
